import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useState } from "react";
export const AVAILABLE_COUNTRIES = [{
  label: "All countries",
  emoji: "🌎",
  checked: true,
  all: true
},
// Most popular countries
{
  label: "United States",
  emoji: "🇺🇸",
  checked: false
}, {
  label: "United Kingdom",
  emoji: "🇬🇧",
  checked: false
}, {
  label: "Canada",
  emoji: "🇨🇦",
  checked: false
}, {
  label: "Australia",
  emoji: "🇦🇺",
  checked: false
},
// European countries
{
  label: "Spain",
  emoji: "🇪🇸",
  checked: false
}, {
  label: "Italy",
  emoji: "🇮🇹",
  checked: false
}, {
  label: "Germany",
  emoji: "🇩🇪",
  checked: false
}, {
  label: "France",
  emoji: "🇫🇷",
  checked: false
}, {
  label: "Netherlands",
  emoji: "🇳🇱",
  checked: false
}, {
  label: "Sweden",
  emoji: "🇸🇪",
  checked: false
}, {
  label: "Norway",
  emoji: "🇳🇴",
  checked: false
}, {
  label: "Slovakia",
  emoji: "🇸🇰",
  checked: false
}, {
  label: "Greece",
  emoji: "🇬🇷",
  checked: false
}, {
  label: "Switzerland",
  emoji: "🇨🇭",
  checked: false
}, {
  label: "Turkey",
  emoji: "🇹🇷",
  checked: false
}, {
  label: "Poland",
  emoji: "🇵🇱",
  checked: false
}, {
  label: "Belgium",
  emoji: "🇧🇪",
  checked: false
}, {
  label: "Romania",
  emoji: "🇷🇴",
  checked: false
}, {
  label: "Czech Republic",
  emoji: "🇨🇿",
  checked: false
}, {
  label: "Austria",
  emoji: "🇦🇹",
  checked: false
}, {
  label: "Portugal",
  emoji: "🇵🇹",
  checked: false
}, {
  label: "Hungary",
  emoji: "🇭🇺",
  checked: false
}, {
  label: "Ireland",
  emoji: "🇮🇪",
  checked: false
},
// Latin American countries
{
  label: "Brazil",
  emoji: "🇧🇷",
  checked: false
}, {
  label: "Mexico",
  emoji: "🇲🇽",
  checked: false
}, {
  label: "Argentina",
  emoji: "🇦🇷",
  checked: false
}, {
  label: "Colombia",
  emoji: "🇨🇴",
  checked: false
}, {
  label: "Chile",
  emoji: "🇨🇱",
  checked: false
},
// Asian countries
{
  label: "Philippines",
  emoji: "🇵🇭",
  checked: false
}, {
  label: "Singapore",
  emoji: "🇸🇬",
  checked: false
}, {
  label: "United Arab Emirates",
  emoji: "🇦🇪",
  checked: false
}, {
  label: "Indonesia",
  emoji: "🇮🇩",
  checked: false
}, {
  label: "India",
  emoji: "🇮🇳",
  checked: false
},
// Other countries
{
  label: "New Zealand",
  emoji: "🇳🇿",
  checked: false
}];
const IGCountriesOptions = t0 => {
  const $ = _c(12);
  const {
    selectedCountries,
    onChange
  } = t0;
  let t1;
  if ($[0] !== selectedCountries) {
    t1 = () => {
      const updatedCountries = AVAILABLE_COUNTRIES.map(country => ({
        ...country,
        checked: selectedCountries && Array.isArray(selectedCountries) && selectedCountries.includes(country.label.toLowerCase())
      }));
      return updatedCountries;
    };
    $[0] = selectedCountries;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [checkboxes, setCheckboxes] = useState(t1);
  let t2;
  if ($[2] !== checkboxes || $[3] !== onChange) {
    t2 = index => {
      const updatedCheckboxes = [...checkboxes];
      if (updatedCheckboxes[index].all) {
        if (updatedCheckboxes[index].checked === true && updatedCheckboxes.every(_temp)) {
          return;
        }
        updatedCheckboxes.forEach(_temp2);
        updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;
      } else {
        updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;
        if (!updatedCheckboxes.some(_temp3)) {
          updatedCheckboxes[0].checked = true;
        } else {
          updatedCheckboxes[0].checked = false;
        }
      }
      setCheckboxes(updatedCheckboxes);
      onChange(updatedCheckboxes.filter(_temp4).map(_temp5));
    };
    $[2] = checkboxes;
    $[3] = onChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCheckboxChange = t2;
  let t3;
  if ($[5] !== checkboxes || $[6] !== handleCheckboxChange) {
    let t4;
    if ($[8] !== handleCheckboxChange) {
      t4 = (checkbox_4, index_0) => <button key={index_0} onClick={() => handleCheckboxChange(index_0)} className={clsx("text-md mx-0.5 my-1 cursor-pointer whitespace-nowrap rounded-xl px-3 py-2 font-medium transition-all duration-300", checkbox_4.checked ? "bg-indigo-500 text-white text-shadow" : "shadow-xs transform border-transparent bg-white text-gray-500 transition-all hover:translate-x-0.5 hover:translate-y-0.5 hover:scale-90 hover:border-gray-300 hover:text-gray-700")}><span className="mr-2">{checkbox_4.emoji}</span>{checkbox_4.label}</button>;
      $[8] = handleCheckboxChange;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = checkboxes.map(t4);
    $[5] = checkboxes;
    $[6] = handleCheckboxChange;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <div className="mb-2 mt-1 flex flex-wrap justify-start gap-2 rounded-xl border-1 border-gray-200 bg-dashbg px-4 py-5 font-dashboard lg:justify-center">{t3}</div>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default IGCountriesOptions;
function _temp(checkbox) {
  return checkbox.checked === false || checkbox.all === true;
}
function _temp2(checkbox_0, i) {
  if (!checkbox_0.all) {
    checkbox_0.checked = false;
  }
}
function _temp3(checkbox_1) {
  return checkbox_1.checked && !checkbox_1.all;
}
function _temp4(checkbox_2) {
  return checkbox_2.checked;
}
function _temp5(checkbox_3) {
  return checkbox_3.label.toLocaleLowerCase();
}